import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import styled, { keyframes } from "styled-components";

interface PaymentSuccessModalProps {
  open: boolean;
  onClose: () => void;
}

const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const checkBounce = keyframes`
  0% { transform: scale(0); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px 8px 8px;
  animation: ${scaleIn} 0.3s ease-out;
`;

const IconWrapper = styled.div`
  color: #34a853;
  margin-bottom: 20px;
  animation: ${checkBounce} 0.5s ease-out 0.2s both;

  svg {
    font-size: 72px;
  }
`;

const Title = styled.h2`
  font-family: "Roboto", sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: #202124;
  margin: 0 0 12px;
`;

const Subtitle = styled.p`
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  color: #5f6368;
  line-height: 1.6;
  margin: 0 0 24px;
  max-width: 400px;
`;

const ActionButton = styled.button`
  background: #4285f4;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  width: 100%;
  max-width: 280px;

  &:hover {
    background: #3367d6;
  }
`;

export const PaymentSuccessModal: React.FC<PaymentSuccessModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "8px",
          maxWidth: "480px",
        },
      }}
    >
      <IconButton
        aria-label="fechar"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 12,
          top: 12,
          color: "#9aa0a6",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <ModalWrapper>
          <IconWrapper>
            <CheckCircleOutlineIcon />
          </IconWrapper>
          <Title>Pagamento realizado com sucesso!</Title>
          <Subtitle>
            Obrigado pela sua compra! Seu perfil já está sendo preparado e em
            breve estará otimizado. Acompanhe o progresso diretamente nesta
            página.
          </Subtitle>
          <ActionButton onClick={onClose}>Entendido</ActionButton>
        </ModalWrapper>
      </DialogContent>
    </Dialog>
  );
};
